import React, { useState, useEffect } from 'react'
import './NavbarDashboard.css'
import { Link as Anchor, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faBook, faImage, faAddressBook, faTachometerAlt, faCode, faClipboardList, faPaintBrush, faLifeRing } from '@fortawesome/free-solid-svg-icons';
import defaultLogo from '../../../images/logo.png'
import Logout from '../Logout/Logout';
import baseURL from '../../url';
import { guardarSiteConfig, obtenerLogoGuardado } from '../../siteConfig';

export default function Navbar() {
    const location = useLocation();
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);

    useEffect(() => {
        cargarLogo();

        const syncLogoFromConfig = (event) => {
            const logo = event?.detail?.logo || obtenerLogoGuardado();
            if (logo) {
                setAppLogo(logo);
            }
        };

        window.addEventListener('site-config-updated', syncLogoFromConfig);
        window.addEventListener('storage', syncLogoFromConfig);

        return () => {
            window.removeEventListener('site-config-updated', syncLogoFromConfig);
            window.removeEventListener('storage', syncLogoFromConfig);
        };
    }, []);

    const cargarLogo = async () => {
        try {
            const response = await fetch(`${baseURL}/configGet.php?ts=${Date.now()}`, {
                cache: 'no-store',
            });
            const data = await response.json();
            if (data.config) {
                guardarSiteConfig(data.config);
            }
            if (data.config?.logo) {
                setAppLogo((currentLogo) => currentLogo === data.config.logo ? currentLogo : data.config.logo);
            }
        } catch (error) {
            console.error('Error al cargar el logo:', error);
        }
    };


    return (

        <div className="navbarDashboard" >
            <Anchor className='logo'>
                <img src={appLogo} alt="logo" />

            </Anchor>
            <div className='links'>
                <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}><FontAwesomeIcon icon={faHome} /> Tienda</Anchor>
                <Anchor to={`/dashboard/productos`} className={location.pathname === '/dashboard/productos' ? 'activeLink' : ''} ><FontAwesomeIcon icon={faBook} /> Productos</Anchor>
                <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLink' : ''}><FontAwesomeIcon icon={faClipboardList} /> Pedidos</Anchor>
                <Anchor to={`/dashboard/categorias`} className={location.pathname === '/dashboard/categorias' ? 'activeLink' : ''}><FontAwesomeIcon icon={faTachometerAlt} /> Categorias</Anchor>
                <Anchor to={`/dashboard/banners`} className={location.pathname === '/dashboard/banners' ? 'activeLink' : ''}><FontAwesomeIcon icon={faImage} /> Banners</Anchor>
                <Anchor to={`/dashboard/diseno`} className={location.pathname === '/dashboard/diseno' ? 'activeLink' : ''}><FontAwesomeIcon icon={faPaintBrush} /> Diseño</Anchor>
                <Anchor to={`/dashboard/contacto`} className={location.pathname === '/dashboard/contacto' ? 'activeLink' : ''}><FontAwesomeIcon icon={faAddressBook} /> Contacto</Anchor>
                <Anchor to={`/dashboard/usuarios`} className={location.pathname === '/dashboard/usuarios' ? 'activeLink' : ''}><FontAwesomeIcon icon={faUser} /> Usuarios</Anchor>
                <Anchor to={`/dashboard/codigos`} className={location.pathname === '/dashboard/codigos' ? 'activeLink' : ''}><FontAwesomeIcon icon={faCode} /> Códigos de descuento</Anchor>
                <Anchor to={`/dashboard/tickets-soporte`} className={location.pathname === '/dashboard/tickets-soporte' ? 'activeLink' : ''}><FontAwesomeIcon icon={faLifeRing} /> Tickets de soporte</Anchor>
            </div>

            <Logout />

        </div>

    );
}
